import { render, staticRenderFns } from "./Toyuyue.vue?vue&type=template&id=129a7b72&scoped=true&"
import script from "./Toyuyue.vue?vue&type=script&lang=js&"
export * from "./Toyuyue.vue?vue&type=script&lang=js&"
import style0 from "./Toyuyue.vue?vue&type=style&index=0&id=129a7b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129a7b72",
  null
  
)

export default component.exports